/** localStorage key of the cover banner's dismissal, `{ dismissedAt }` in epoch ms. */
export const COVER_BANNER_DISMISSAL_KEY = "fido-cover-banner-dismissal";

/** How long a closed cover banner stays hidden in that browser (B7). */
export const COVER_BANNER_HIDDEN_DAYS = 30;
